var _radialGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "50%",
    cy: "46.801102%",
    r: "95.497112%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919eab",
    stopOpacity: 0.48
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88 86h512v512h-512z",
    fill: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(-88 -86)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img_placeholder.ccd4d743621841d4871888cd41344117.svg";
export { ForwardRef as ReactComponent };